// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolToolType, SelectionModeEnum } from "../DataCacheToolEnums.js";
import { DataCacheTool } from "../DataCacheTool.js";


export let VerticalLineDataCacheTool = function ()
{
    DataCacheTool.apply(this);
    this.ToolType = DataCacheToolToolType.VerticalLine;
    this.InitPoints(1);
};

VerticalLineDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

VerticalLineDataCacheTool.prototype.InitBlock = function ()
{
    DataCacheTool.prototype.InitBlock.apply(this);
    this.SelectionMode = SelectionModeEnum.X;
};

VerticalLineDataCacheTool.prototype.MinPointsCount = function () { return 1; };
VerticalLineDataCacheTool.prototype.MaxPointsCount = function () { return 1; };